import { takeLatest } from 'redux-saga/effects';
import { clearToken } from '../../utilities/tokenStorage';
import { LOGOUT } from '../reducer';

export function* logoutSaga() {
  yield takeLatest(LOGOUT, clearToken);
}
